import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function MovingBallIcon(props: IconProps) {
  return (
    <Icon width="24px" height="7px" fill="none" viewBox="0 0 24 7" {...props}>
      <Box as="path" fill={`url(#group-29098__a${props.id ?? ""})`} d="M0 .5h21v6H0z" />
      <rect width="6" height="6" x="18" y=".5" fill="#00A341" rx="3" />
      <defs>
        <linearGradient
          id={`group-29098__a${props.id ?? ""}`}
          x1="21"
          x2="0"
          y1="6.5"
          y2="6.5"
          gradientUnits="userSpaceOnUse"
        >
          <Box as="stop" stopColor="#00A341" stopOpacity=".3" />
          <Box as="stop" offset="1" stopColor="#00A341" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
